import dotenv from 'dotenv'

dotenv.config({ path:"./.env" })



const getData = async (module, cache='no-store', credentials, authorizationToken, cookie, sourceComponent) => {
     // cache can be force-cache or no-store

     /*
     Cookie can be retrieved in multiple ways. 
     Here's how cookie is retrieved:
     > const tokenCookie = req?.cookies?._parsed?.get('token')?.value || req.cookies.token || req.headers.cookies || req.headers.authorization || req.headers.get('Authorization')

     *** At the time of this comment, only /app/[lang]/talent/[talent]/page.js uses "cookie", nothing uses authorizationToken, everything else uses credentials: include
     */

     const baseUrl = process.env.NODE_ENV === 'development' ? 'http://localhost:3000' : 'https://talnet.co';

     const res = await fetch(`${baseUrl}/api/${module}`, {
          
          method: 'GET', 
          credentials: credentials,
          headers: {
               'Accept': '*/*', 
               'Content-Type': 'application/json', 
               'Cookie': cookie,
               'Authorization': authorizationToken, 
               'X-Source': sourceComponent
          },
          cache: cache,
          // next: { revalidate: 3600  } // remove this
     })
    
     if (!res.ok) {
    console.log("RES", res);

    let response = {};
    try {
        response = await res.json();
    } catch (err) {
        console.warn("Response not JSON, returning empty object");
    }

    response = {
        ...response,
        status: res.status,
        statusText: res.statusText
    };

    return response;
}

     // if (!res.ok) {
     //      console.log("RES", res)
     //   // This will activate the closest `error.js` Error Boundary
     // //   throw new Error('Failed to fetch data')

     // let response = await res.json()
     //      if (response){
     //           response = {
     //                ...response, 
     //                status: res.status
     //           }
     //      }
     //      return response
     // }

     let response = await res.json()
     if (response){
          response = {
               ...response, 
               status: res.status
          }
     }
     // console.log("RESPONSE", response)
     return response
     // return res.json()
     // return res.json()
}

const getTagsRecords = async (setLoading = ()=> {}) => { // dependant on getData above
          setLoading(true)
          try {
               let response = await getData('tags', 'no-store', undefined, undefined, undefined)
               return response.data
          }
          catch (error) {
               console.error('Failed to fetch tags:', error);
          }
          finally {
               setLoading(false)
          }
     }

// const getThisUserServer = async () =>{ 
//      // this is server side user
//      const token = await getCookiesServer('token', 'string')

//        let user;
//   if (token) {
//   try {
//     user = jwt.verify(token, getCookieSignature());
//   } catch (e) {
//     user = null;
//   }
//   }
//   return user;
// }


//   const getSocialPosts = async ({
//      user, 
//      cookies = ()=> {},
//     feed = 'all',
//     topic = null,
//     parentUUID = null,
//     extraParams = null
//   } = {}) => {
//   const params = new URLSearchParams();

//   params.set('user_type', user?.user_type);

//   if (parentUUID) {
//     params.set('filter', 'true');
//     params.set('parent_social_post_uuid', parentUUID);
//   }

//   if (feed === 'following') {
//     params.set('filter', 'true');
//     params.set('feed_preference', 'FOLLOWING');
//   }

//   else if (topic) {
//     params.set('filter', 'true');
//     params.set('topic', topic);
//   }

//   else if (extraParams){
//     params.set('filter', 'true')
//   }

//   const data = await getData(
//     `social/posts?${params.toString()}${extraParams}`,
//     undefined,
//     undefined,
//     undefined,
//     (await cookies()).toString(),
//     'getSocialPosts@social/page.js'
//   );


//   return data.data?.reverse();
// };





export {getData, getTagsRecords}